import React from 'react'
import * as systemLogos from '../../../static/svg/systemLogos'

import { SYSTEM_ICON } from '../constants'

const logoMap: Record<string, string> = systemLogos

const getSystemLogo = (systemCode: string, systemName?: string) => {
  const iconName = SYSTEM_ICON[systemCode]
  const icon = logoMap[iconName]

  if (icon) {
    return (
      <img
        width="30"
        height="30"
        src={icon}
        alt={systemName ? `${systemName} icon` : `${systemCode} icon`}
      />
    )
  }
}

export default getSystemLogo
